import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { AdjudicationResult } from '@core/model';

@Component({
    selector: 'app-negotiation-pvps',
    templateUrl: './negotiation-pvps.component.html',
    styleUrls: ['./negotiation-pvps.component.scss'],
    standalone: false
})
export class NegotiationPvpsComponent implements OnInit {
  @Output() adjudicationChanged = new EventEmitter<AdjudicationResult>();
  @Output() submitNegotiationPvps = new EventEmitter<boolean>();
  @Input() adjudication: AdjudicationResult;

  isVisible = true;
  negotiationForm: FormGroup;
  formValid = false;

  ngOnInit() {
    this.createForm();
    this.setFormValidity();
  }

  setLineAcceptOrReject(index, selectedValue: string) {
    this.adjudication.negotiations[index].acceptOrReject = selectedValue;
    this.adjudicationChanged.emit(this.adjudication);
    this.setFormValidity();
  }

  handleNegotiationCompleted() {
    this.submitNegotiationPvps.emit(true);
  }

  private createForm() {
    this.negotiationForm = new FormGroup({
      negotiations: new FormArray(
        this.adjudication.negotiations.map((value, index) => new FormGroup({
          [`acceptOrReject_${index}`]: new FormControl(value.acceptOrReject, Validators.required)
        }))
      )
    });
  }

  private setFormValidity() {
    this.formValid = this.adjudication.negotiations.findIndex(e => e.acceptOrReject === null) === -1;
  }
}
